import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class RoadmapTableInitiativeSettingsIndexRoute extends Route {
  @service router;

  // beforeModel() {
  //   this.router.transitionTo('backlog.initiatives.initiative.settings.general-details');
  // }
}

export default instrumentRoutePerformance(
  RoadmapTableInitiativeSettingsIndexRoute,
);
